// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hFV5pLbexK2rrt {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px 0 8px;
}
@media only screen and (max-width: 750px), only screen and (min-width: 751px) and (max-width: 900px) {
  .hFV5pLbexK2rrt {
    flex-direction: column;
  }
}
@media only screen and (max-width: 750px) {
  .hFV5pLbexK2rrt {
    padding: 8px 0;
  }
}
.Rz5Cw84HMMYNqL {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
@media only screen and (max-width: 750px), only screen and (min-width: 751px) and (max-width: 900px) {
  .Rz5Cw84HMMYNqL.fUCX_AXkcTSx15 {
    flex-direction: column;
  }
}
.dpTvHZ1N8Z4vHc {
  flex-direction: column;
  margin-right: 4px;
}
.DY90fhLrPrK1z6 {
  display: flex;
  flex-direction: column;
}
.NBtruaten1qZfd {
  width: 200px;
}
.L8lYmigF1f1ZSN {
  position: absolute;
  top: 4px;
  right: 1px;
}
.L8lYmigF1f1ZSN:hover,
.L8lYmigF1f1ZSN:active {
  background-color: transparent;
}
.UpdvhP1apoizKr input {
  width: 250px;
}
.UpdvhP1apoizKr input[placeholder] {
  text-overflow: ellipsis;
}
.c0pkiNSp1dVJZ6 {
  font-weight: var(--ds-font-weight-bold, 700);
  margin-top: 12px;
  margin-bottom: 4px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: block;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterBar": `hFV5pLbexK2rrt`,
	"sortFilterElement": `Rz5Cw84HMMYNqL`,
	"fullscreen": `fUCX_AXkcTSx15`,
	"formElement": `dpTvHZ1N8Z4vHc`,
	"searchFormElement": `DY90fhLrPrK1z6`,
	"sortDropdown": `NBtruaten1qZfd`,
	"closeButton": `L8lYmigF1f1ZSN`,
	"textfield": `UpdvhP1apoizKr`,
	"label": `c0pkiNSp1dVJZ6`
};
export default ___CSS_LOADER_EXPORT___;
